"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var ClaimsTable_1 = require("./ClaimsTable");
var ClaimsAuditTable_1 = require("./ClaimsAuditTable");
var ClaimsForm_1 = require("./ClaimsForm");
var ProductSelector_1 = require("./ProductSelector");
var Claims = /** @class */ (function (_super) {
    __extends(Claims, _super);
    function Claims(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            claims: [],
            claimsAudit: [],
            deleted: _this.props.location.state && _this.props.location.state.deleted
        };
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }
    Claims.prototype.componentDidMount = function () {
        this.updateClaimList();
        this.updateClaimAuditList();
    };
    Claims.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.selectedDriver !== this.props.selectedDriver) {
            this.updateClaimList();
            this.updateClaimAuditList();
        }
    };
    Claims.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.showMessage("Claim deleted"), (0, jsx_runtime_1.jsxs)("div", { className: "col-12 mb-3", children: [(0, jsx_runtime_1.jsxs)("h2", { children: ["Claims for ", this.props.selectedDriver.name] }), this.state.claims.length === 0
                            ? (0, jsx_runtime_1.jsx)("p", { className: "text-muted", children: "Customer has no claims" })
                            : (0, jsx_runtime_1.jsx)(ClaimsTable_1.ClaimsTable, __assign({ clientReferenceNumber: this.props.params.id, claims: this.state.claims }, this.props))] }), (0, jsx_runtime_1.jsxs)("div", { className: "col-12", children: [(0, jsx_runtime_1.jsx)("h2", { children: "Add claim" }), (0, jsx_runtime_1.jsx)(ProductSelector_1.ProductSelector, { getProduct: function (product) { return _this.setState({ product: product }); }, value: this.state.product }), this.state.product && ((0, jsx_runtime_1.jsx)(ClaimsForm_1.ClaimsForm, __assign({ product: this.state.product, onSubmit: this.handleSubmit, submitText: "Add" }, this.props)))] }), this.state.claimsAudit.length === 0 ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) :
                    (0, jsx_runtime_1.jsxs)("div", { className: "col-12 mb-3 overflow-auto", children: [(0, jsx_runtime_1.jsxs)("h2", { children: ["Claims audit trace for ", this.props.selectedDriver.name] }), (0, jsx_runtime_1.jsx)(ClaimsAuditTable_1.ClaimsAuditTable, __assign({ clientReferenceNumber: this.props.params.id, claimsAudit: this.state.claimsAudit }, this.props))] })] }));
    };
    Claims.prototype.showMessage = function (buttonName) {
        var _this = this;
        if (this.state.deleted) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "alert alert-danger alert-dismissible col-12", role: "alert", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", onClick: function () { return _this.setState({ deleted: false }); }, children: (0, jsx_runtime_1.jsx)("span", { "aria-hidden": "true", children: "\u00D7" }) }), buttonName] }));
        }
        else {
            return "";
        }
    };
    Claims.prototype.handleSubmit = function (claimRequest) {
        var _this = this;
        this.supportPortalService.createClaim(this.props.params.id, claimRequest).subscribe(function (claim) {
            _this.setState({ claims: __spreadArray(__spreadArray([], _this.state.claims, true), [claim], false), product: "" });
            _this.updateClaimAuditList();
        });
    };
    Claims.prototype.updateClaimList = function () {
        var _this = this;
        this.supportPortalService.getClaims(this.props.selectedDriver.driverIds[0].toString()).subscribe(function (claims) { return _this.setState({ claims: claims }); });
    };
    Claims.prototype.updateClaimAuditList = function () {
        var _this = this;
        this.supportPortalService.getClaimsAudit(this.props.selectedDriver.driverIds[0].toString()).subscribe(function (claimAudit) { return _this.setState({ claimsAudit: claimAudit }); });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], Claims.prototype, "supportPortalService", void 0);
    Claims = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], Claims);
    return Claims;
}(React.Component));
exports.default = Claims;
//# sourceMappingURL=Claims.js.map